import Controller from "./captainFinance.controller";
import template from "./captainFinance.html";

const captainFinance = {
  template,
  controller: Controller,
};

export default captainFinance;



// WEBPACK FOOTER //
// ./src/pages/captainFinance/captainFinance.component.js